export default "__VITE_ASSET__DEOGdEsS__"